import { joinPath } from '../../core/utils';
import type { ComputeBlockOptions, ComputePaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveComputePaths(prefix: string, _options?: ComputeBlockOptions): ComputePaths {
  const architecturePath = 'system.architecture';

  return {
    architecture: architecturePath,
    cpuCards: joinPath(prefix, 'cpu.physicalCards'),
    cpuCores: joinPath(prefix, 'cpu.physicalCores'),
    cpuLogical: joinPath(prefix, 'cpu.logicalCores'),
    cpuRequest: joinPath(prefix, 'cpu.request'),
    /** 与 modules / resourceConfigs / sku reset 一致：resource.cpuPricing（非 cpu.pricing） */
    cpuPricing: joinPath(prefix, 'cpuPricing'),
    memory: joinPath(prefix, 'memory'),
    memoryPricing: joinPath(prefix, 'memoryPricing'),
    gpu: joinPath(prefix, 'gpu'),
    gpuPricing: joinPath(prefix, 'gpuPricing'),
    bandwidth: joinPath(prefix, 'network.Bandwidth'),
    bandwidthPricing: joinPath(prefix, 'network.bandwidthPricing'),
    hpcRdma: joinPath(prefix, 'network.hpc.elasticRdma'),
  };
}
